import type { ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { CURRENT_SPRINT, SPRINT_PLAN, hideWhenLocked, isUnlocked, sprintOf } from '@waago/api'
import { LockedScreen } from '@waago/ui'

/**
 * Holds back a screen that belongs to a later sprint. See the client app's
 * twin — same reasoning, one gate per app because the route tables (and
 * what `/compte` means) differ.
 */
export function SprintGate({ children }: { children: ReactNode }) {
  const location = useLocation()
  const navigate = useNavigate()

  if (isUnlocked(location.pathname)) return <>{children}</>

  if (hideWhenLocked()) {
    return (
      <p role="status" className="p-8 text-center text-sm text-slate-500">
        Page introuvable.
      </p>
    )
  }

  const sprint = sprintOf(location.pathname)
  const plan = SPRINT_PLAN[sprint]
  return (
    <LockedScreen
      sprint={sprint}
      days={plan.days}
      scope={plan.title}
      currentSprint={CURRENT_SPRINT}
      onBack={() => void navigate('/', { replace: true })}
    />
  )
}
